import React from "react";
import Navbar from "../../components/PSTVue/Navbar2";
import HeroSection from "../../components/PSTVue/HeroSection";
import OurImpact from "../../components/PSTVue/OurImpact";

const PSTMission = () => {
  return (
    <main>
      <div className="relative z-50">
        <Navbar />
      </div>
      <div className="bg-white relative z-10">
        <HeroSection />
        <OurImpact />
      </div>
    </main>
  );
};

export default PSTMission;